import dictionary from './dictionary.json.js';
const config = {
    resource: 'next-cookie-banner',
    dictionary,
};
export default config;
//# sourceMappingURL=config.js.map